


























import NavBar from '@/components/Login/navBar.vue';
import { companyHost } from '@/consts/companyHost';
import Vue from 'vue';

export default Vue.extend({
  name: 'AuthenticationLayout',
  components: { NavBar, },
  data: () => ({
    loginBackground: process.env.VUE_APP_LOGIN_BACKGROUND,
    companyHost,
    currentYear: new Date().getFullYear(),
    tenantName: process.env.VUE_APP_TENANT_NAME || 'My Tenant',
    websiteUrl: process.env.VUE_APP_WEBSITE_URL || 'https://example.com',
  }),
  computed: {
    backgroundStyle() {
      return {
        backgroundImage: `url('${this.loginBackground}')`,
      };
    },
  },
});
